import React from 'react';

const AdvantageItem = ({ icon, icon_title, alt, text, fine_print }) => (
  <div className="advantage">
    <p className="container">
      <span
        className="advantage-icon"
        style={{ background: `url(${icon})` }}
        alt={alt}
        title={icon_title}
      />
      <span className="ornament" />
      <span className="content">
        <span
          dangerouslySetInnerHTML={{
            __html: text
          }}
        />
        {fine_print && (
          <span
            className="fine-print"
            dangerouslySetInnerHTML={{
              __html: fine_print
            }}
          />
        )}
      </span>
    </p>
  </div>
);

export default AdvantageItem;



// WEBPACK FOOTER //
// ./app/javascript/common/components/german_operators_banner/AdvantageItem.jsx